/**
 *
 * Marquee Init
 *
 */

jQuery(function($) {
  $('html').addClass('is-ready');

  if ($('.marquee').length) { // Check if any elements with class "marquee" exist
    $('.marquee').marquee({
      speed: 10
    });
  }
});





/**
 *
 * Menu OffCanvas Animation
 *
 */



// jQuery(function ($) {
//   function toggleMenu() {
//     $('.nav-trigger span').toggleClass('active --initial');
//     $("body").toggleClass("offcanvas--open");
//     $(".offcanvas-collapse, .collapse-bg").toggleClass("show");

//   }

//   function closeMenu() {
//     $(".offcanvas-toggler").removeClass("collapsed");
//     $(".offcanvas-collapse, .collapse-bg").removeClass("show");
//     $('.nav-trigger span').removeClass('active');
//     $("body").removeClass("offcanvas--open");
//   }

//   $('#burger-nav_').click(function (event) {
//     alert('Link clicked');;

//     event.preventDefault();
//     toggleMenu();
//   });

//   $(".collapse-bg").click(closeMenu);

//   // Close menu when anchor links are clicked
//   $('.offcanvas-collapse a[href^="#"]').click(function(event) {
//     event.preventDefault();
//     alert('Link clicked');;
//     closeMenu();
    
//     // Smooth scroll to the target (optional)
//     var target = $(this.hash);
//     if (target.length) {
//       $('html, body').animate({
//         scrollTop: target.offset().top
//       }, 1000);
//     }
//   });
// });







jQuery(function ($) {


  gsap.registerPlugin(ScrollTrigger);



/**
 *
 * General Scroll CSS Class Definition
 *
 */

  const body = document.querySelector("body");

  // Create a ScrollTrigger instance
  ScrollTrigger.create({
    trigger: body,
    start: "100px top",
    end: "top -100px",
    onEnter: () => body.classList.add("--is-scrolled"),  // Add class when entering the trigger
    onLeaveBack: () => body.classList.remove("--is-scrolled"),  // Remove class when scrolling back
  });


  const elements = gsap.utils.toArray('.--has-animation');

  elements.forEach((element) => {
    gsap.from(element, {
      scrollTrigger: {
        // markers: {startColor: "yellow", endColor: "yellow", fontSize: "18px", fontWeight: "bold", indent: 20},

        start: 'top 80%',
        end: 'bottom 20%',
        trigger: element,
        toggleClass: '--in-viewport',
        onEnter: () => {
          if (!$(element).hasClass("--animated")) {
            $(element).addClass("--in-viewport");
            setTimeout(() => {
              $(element).addClass("--animated");
        }, 3500); // 500ms Verzögerung
          }
        },
        onLeaveBack: () => {
          $(element).removeClass("--in-viewport");
        },
      }
    });
  });



/**
 *
 * Menu Border Animation
 *
 */


  const borderAnimation = gsap.to('#main-nav', {
  borderBottomColor: 'rgba(0, 0, 0, 0)', // Endet schwarz
  paused: true
});

  ScrollTrigger.create({
    start: "100px top",
    end: "top -100px",
    scrub: true,
    onUpdate: (self) => {
      borderAnimation.progress(self.progress);
    }
  });



  gsap.to('#main-nav', {
    x:0,
    scrollTrigger: {
     trigger: "#main-nav",
     start: "-20px top",
     end: "+=250",
     scrub: true,
     toggleClass: 'is-top',
    // markers: true,
   }
 });





/**
 *
 * Line-by-Line Animation
 *
 */



  let addAnimation = function () {
    $(" .skew-up, .--has-animation .wp-block-heading").each(function (index) {
      const text = new SplitType($(this), {
        types: "lines, words",
        lineClass: "word-line"
      });

  // Loop through each parent with class .has-dot
      $('.has-dot').each(function() {
        $(this).find('.word-line').each(function(innerIndex) {
          let parentWrapper = $(this).parent();

          if (!parentWrapper.hasClass('word-line-wrapper')) {
            let displayStyle = innerIndex === 0 ? 'inline-flex' : 'flex';
            $(this).wrap(`<div class="word-line-wrapper" style="display: ${displayStyle}"></div>`);
          }
        });
      });
  // Loop through other word-line elements that are not children of .has-dot
      $('.word-line').not($('.has-dot .word-line')).each(function() {
        let parentWrapper = $(this).parent();

        if (!parentWrapper.hasClass('word-line-wrapper')) {
          $(this).wrap('<div class="word-line-wrapper" style="display: flex"></div>');
        }
      });



    });
  };

  addAnimation();
  window.addEventListener("resize", function (event) {
    if ($(window).width() >= 992) {
      addAnimation();
    }
  });


/**
 *
 * BG Image Opacity and Move Animation on Scroll
 *
 */
  const heroBg = document.querySelector(".hero-bg");
  const contentContainer = document.querySelector(".content-container");


  if (heroBg && contentContainer) {

// Initial setup
    gsap.set(heroBg, { backgroundSize: "100%", opacity: 0 });
  // gsap.set(contentContainer, { opacity: 1, y: 0 });

// Initial animation
    const tl = gsap.timeline()
    .to(heroBg, {
      duration: 2.3,
      opacity: 1,
      backgroundSize: "105%",
      delay: 0.8,
      onComplete: () => {
        gsap.set(heroBg, { backgroundSize: "105%" });
      }
    });



// ScrollTrigger animation
    gsap.to(heroBg, {
      backgroundSize: "125%",
      scrollTrigger: {
        trigger: "body",
        start: "top top",
        end: () => `+=${heroBg.offsetHeight}px`,
        scrub: .3,
        immediateRender: false,
      // markers: true,
        onEnter: () => gsap.to(heroBg, { opacity: 0.5, duration: 1 }),
        onLeaveBack: () => gsap.to(heroBg, { opacity: 1, duration: 1 })
      }
    });

// Content container ScrollTrigger animation
    gsap.to(contentContainer, {
    // opacity: 0,
      y: -100,
      scrollTrigger: {
        trigger: contentContainer,
        start: "center center",
        end: "bottom center",
        scrub: .5,
        immediateRender: false,
      // markers: true,
      // onEnter: () => gsap.to(contentContainer, { opacity: 0, y: -50, duration: 1 }),
      // onLeaveBack: () => gsap.to(contentContainer, { opacity: 1, y: 0, duration: 1 })
      }
    });

  }


/**
 *
 * Footer Parallax Animation
 *
 */

  // if (window.innerWidth > 768) { 
  gsap.set('#wrapper-footer', { yPercent: -50 })

  const uncover = gsap.timeline({ paused:true })

  uncover
  .to('#wrapper-footer', { yPercent: 0, ease: 'none' })
  ;


  ScrollTrigger.create({
    trigger: '#full-width-page-wrapper',
    start: 'bottom bottom',
    end: '+=105%',
    animation: uncover,
    scrub: true,
      // markers: true
  });


  // }




});


/**
 *
 * Off-Canvas Menü Animation
 *
 */



jQuery(function ($) {
  var t1 = gsap.timeline({ paused: true });

  t1.to(".offcanvas-collapse__", 1, {
    top: 0,
    ease: Expo.easeInOut,
  });

  t1.staggerFrom(
    ".menu-main-menu-container ul > li",
    0.8,
    { x: -100, opacity: 0, ease: Expo.easeOut },
    "0.1",
    "-=0.4"
    );

  t1.staggerFrom(
    ".copyright--holder",
    0.8,
    { x: -100, opacity: 0, ease: Expo.easeOut },
    "0.4",
    "-=0.6"
    );
  t1.staggerFrom(
    ".header--holder",
    0.8,
    { y: -100, opacity: 0, ease: Expo.easeOut },
    "0.4",
    "-=0.6"
    );

  t1.reverse();
  $(document).on("click", ".nav-trigger__", function () {
    t1.reversed(!t1.reversed());
  });
  // $(document).on("click", ".nav-trigger__", function () {
  //   t1.reversed(!t1.reversed());
  // });


  function toggleMenu() {
    $('.nav-trigger__ span').toggleClass('active --initial');
    $("body").toggleClass("offcanvas--open");
    $(".offcanvas-collapse, .collapse-bg").toggleClass("show");
    t1.reversed() ? t1.play() : t1.reverse();
  }

  function closeMenu() {
    $(".offcanvas-toggler").removeClass("collapsed");
    $(".offcanvas-collapse, .collapse-bg").removeClass("show");
    $('.nav-trigger__ span').removeClass('active');
    $("body").removeClass("offcanvas--open");
    t1.reverse();
  }

  // $(document).on("click", ".nav-trigger__", function (event) {
  //   event.preventDefault();
  //   toggleMenu();
  // });

  $(".collapse-bg").click(closeMenu);

  // Close menu when anchor links are clicked
  $('.offcanvas-nav-main a').click(function(event) {
    event.preventDefault();
    closeMenu();
    
    // Smooth scroll to the target (optional)
    var target = $(this.hash);
    if (target.length) {
      $('html, body').animate({
        scrollTop: target.offset().top
      }, 1000);
    }
  });
});


/**
 *
 * Image REveal Animation
 *
 */




gsap.utils.toArray(".--has-animation .wp-block-image").forEach((section, index) => {

  const wpBlockImage = section;
  const img = wpBlockImage.querySelector('img');

  // Initialer Zustand
  gsap.set(wpBlockImage, {
    clipPath: "polygon(0 100%, 100% 100%, 100% 100%, 0 100%)",
    visibility: "visible",
    height: wpBlockImage.offsetHeight - 100,
    overflow: "hidden",
  });

  gsap.set(img, {
    scale: 1.4
  });

  ScrollTrigger.create({
    // markers: {startColor: "blue", endColor: "blue", fontSize: "18px", fontWeight: "bold", indent: 20},
    trigger: section,
    start: "top 70%",
    end: "bottom 30%",
    onEnter: () => {
      gsap.to(wpBlockImage, {
        clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
        visibility: "visible",
        duration: 0, // Dauer in Sekunden
        delay: 0.2, // Verzögerung in Sekunden
        ease: "easeOut"
      });

      gsap.to(img, {
        scale: 1,
        duration: 3, // Dauer in Sekunden
        ease: "easeOut",
        scrub: 0,
      });
    }
  });

});

gsap.utils.toArray(".--has-animation .wp-block-image img").forEach((section, index) => {


  gsap.timeline({

    scrollTrigger: {

      trigger: section,
      scrub: 1,
      // markers:true,

      invalidateOnRefresh: true
    }})
  .fromTo(section, { 
    y: () => -100      
  }, {
    y: 0,
    ease: "none"
  });


});









jQuery(function ($) {


  gsap.registerPlugin(ScrollTrigger);


  gsap.to(".img--hero", {

    clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)", 
    duration: 2,
    ease: "none",
    scrollTrigger: {
      trigger: ".img--hero",
      start: "top 95%",
      end: "top 30%",
      scrub: .8,
      // markers: true
    }
  });
  gsap.from(".img--hero img", {

    scale: 1.2,
    duration: 2,
    ease: "none",
    scrollTrigger: {
      trigger: ".img--hero",
      start: "top 95%",
      end: "top 30%",
      scrub: .8,
      // markers: true
    }
  });

  gsap.to(".hero--content", {
    // opacity: 0,
    duration: 2,
    y: 90,
    scrollTrigger: {
      trigger: ".img--hero",
      start: "top 95%",
      end: "top 80%",
      scrub: 2,
      immediateRender: false,
      // pin: ".hero--content",
      // markers: true,
    }
  });

});


